import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, InputNumber, notification, Row, Select, Upload, Modal } from 'antd';
import axios from 'axios';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import offerAPI from '~/api/OfferAPI';
import withdrawAPI from '~/api/Withdraw';
import Wallet from '~/components/Wallet';
import config from '~/config';
import { checkKeyDownNumberInput, getNumberWithCommas } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './Withdraw.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import collabAPI from '~/api/CollabAPI';
import uploadAPI from '~/api/UploadAPI';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { getInfoProfile } from '~/store/actions/UserAction';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';
import FormCanNot from '~/components/FormCanNot';

const { Option } = Select;
const { TextArea } = Input;
const cx = classNames.bind(styles);

const Withdraw = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isLoadingFront, setIsLoadingFront] = useState(false);
    const [isLoadingBack, setIsLoadingBack] = useState(false);

    const userInfo = useSelector((state) => state.user.userInfo);

    const [showAmount, setShowAmount] = useState(false);

    // const [moneyWithdraw, setMoneyWithdraw] = useState(0);
    const [listBank, setListBank] = useState([]);
    const [errorMoneyWithdraw, setErrorMoneyWithdraw] = useState('');

    const [walletRose, setWalletRose] = useState(0);

    const [imageUrlBefore, setImageUrlBefore] = useState();
    const [imageUrlAfter, setImageUrlAfter] = useState();
    const propsBefore = {
        beforeUpload: (file) => {
            const isPNG = file.type === 'image/png' || 'image/jpg' || 'image/jpeg';
            if (!isPNG) {
                // message.error(`${file.name} is not a image file`);
                notification.open({
                    message: 'Please select image format .png/jpg/jpeg',
                    duration: 2,
                    placement: 'top',
                });
            }
            return isPNG || Upload.LIST_IGNORE;
        },
        name: 'avatar',
        listType: 'picture-card',
        accept: 'image/*',
        className: 'avatar-uploader',
        showUploadList: false,
        onChange: (e) => handleChangeImageBefore(e),
    };
    const propsAfter = {
        beforeUpload: (file) => {
            const isPNG = file.type === 'image/png' || 'image/jpg' || 'image/jpeg';
            if (!isPNG) {
                // message.error(`${file.name} is not a image file`);
                notification.open({
                    message: 'It is not a image file',
                    duration: 2,
                    placement: 'top',
                });
            }
            return isPNG || Upload.LIST_IGNORE;
        },
        name: 'avatar',
        listType: 'picture-card',
        accept: 'image/*',
        className: 'avatar-uploader',
        showUploadList: false,
        onChange: (e) => handleChangeImageAfter(e),
    };

    const uploadButtonFront = (
        <div>
            {isLoadingFront ? <LoadingOutlined /> : <PlusOutlined />}
            {/* <PlusOutlined /> */}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Front
            </div>
        </div>
    );
    const uploadButtonBack = (
        <div>
            {isLoadingBack ? <LoadingOutlined /> : <PlusOutlined />}
            {/* <PlusOutlined /> */}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Backside
            </div>
        </div>
    );
    const handleChangeImageBefore = async (e) => {
        setIsLoadingFront(true);
        const formData = new FormData();
        formData.append('image', e?.file?.originFileObj);
        try {
            const response = await uploadAPI.avatarAPI(formData);
            if (response.code === 200) {
                const url = response.results.object.url;
                setImageUrlBefore(url);
            }
        } catch (err) {
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
        setIsLoadingFront(false);
    };
    const handleChangeImageAfter = async (e) => {
        setIsLoadingBack(true);
        const formData = new FormData();
        formData.append('image', e?.file?.originFileObj);
        try {
            const response = await uploadAPI.avatarAPI(formData);
            if (response.code === 200) {
                const url = response.results.object.url;
                setImageUrlAfter(url);
            }
        } catch (err) {
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
        setIsLoadingBack(false);
    };
    const onFinishSendConfirmation = async (e) => {
        try {
            const params = {
                fullname: e.fullname,
                card_id: e.CCCD,
                front_identification: imageUrlBefore,
                back_identification: imageUrlAfter,
                address: e.address,
                phone: e.phone,
            };
            const res = await collabAPI.createCollab(params);

            if (res.code === 200) {
                notification.open({
                    message: 'Send authentication request successfully',
                    duration: 2,
                    placement: 'top',
                });
                dispatch(getInfoProfile());
            }
        } catch (err) {
            notification.open({
                message: err.message,
                duration: 2,
                placement: 'top',
            });
        }
    };

    const handleGetListBank = async () => {
        try {
            let final = [];
            const res = await axios.get('https://api.vietqr.io/v2/banks');
            if (res.data.code === '00') {
                final = res.data.data.map((item) => ({
                    code: item.code,
                    name: item.name,
                }));
            }
            setListBank(final);
        } catch (err) {
            console.log(err);
        }
    };

    const handleGetHistoryWithdraw = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await offerAPI.getHistoryWithdrawAPI(params);

            if (res.code === 200) {
                // setPagination({
                //     wallet_rose: res.results.object.wallet_rose,
                // });
                setWalletRose(res.results.object.wallet_rose);
            }
        } catch (err) {
            console.log(err);
        }
    };

    // const onChange = (value) => {
    //     setMoneyWithdraw(value)
    // };
    const handleChange = (value) => {};
    const onSearch = (value) => {};
    const onFinishSendRequirement = async (values) => {
        try {
            const params = {
                bank_type: values.bank,
                bank_number: values.stk,
                bank_name: values.name_tk,
                change_amount: parseInt(values.moneyWithdraw),
                note: values.note,
            };
            const res = await withdrawAPI.sendWithdraw(params);
            if (res.code === 200) {
                notification.open({
                    message: 'Send withdrawal request successfully',
                    duration: 1.5,
                    placement: 'top',
                });
            }
            navigate(config.routes.historyWithdraw);
        } catch (err) {
            console.log(err);
            notification.open({
                message: err.message,
                duration: 1.5,
                placement: 'top',
            });
            setErrorMoneyWithdraw(err.message);
        }
    };

    useEffect(() => {
        handleGetListBank();
        handleGetHistoryWithdraw();
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangRutTien');
        // eslint-disable-next-line
    }, []);

    const [realMoney, setRealMoney] = useState();
    const [tax, setTax] = useState(0);
    const [isShowTCN, setIsShowTCN] = useState(false);

    const handleChangeWallet = (e) => {
        console.log('Khiem', e);
        if (e > 2000000) {
            setTax(Math.round((e * 10) / 100));
            setRealMoney(Math.round((e * 90) / 100));
        } else {
            setTax(0);
            setRealMoney(e);
        }
    };

    const contentTCN = `
    Article 25, Clause 1, Section I of Circular 111/2013/TT-BTC dated August 15, 2013 of the Ministry of Finance "Organizations and individuals paying wages, remunerations, and other payments to resident individuals do not sign a labor contract (according to the instructions in Points c, d, Clause 2, Article 2 of this Circular) or sign a labor contract of less than three (03) months with a total income of two million (2,000,000) ) VND/time or more, tax must be deducted at 10% of income before paying to individuals."`;

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 1, children: 1 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Request a withdrawal
                        </p>
                        <>
                            {showAmount ? (
                                <EyeOutlined className={cx('icon_show_amount')} onClick={() => setShowAmount(false)} />
                            ) : (
                                <EyeInvisibleOutlined
                                    className={cx('icon_show_amount')}
                                    onClick={() => setShowAmount(true)}
                                />
                            )}
                        </>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>
                        <Col xs={14}>Withdrawal request</Col>
                        <Col xs={10}>
                            <Row justify="end">
                                {showAmount ? (
                                    <EyeOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(false)}
                                    />
                                ) : (
                                    <EyeInvisibleOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(true)}
                                    />
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <div className={cx('right_container')}>
                        <Wallet showAmount={showAmount}></Wallet>
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        <Row className={cx('table_container')}>
                            <Col className={cx('tab_section')}>
                                <div className={cx('tab_item', 'tab_item_selected')}>Withdrawal information</div>
                            </Col>
                            {!userInfo?.collab ? (
                                <Form onFinish={onFinishSendConfirmation} style={{ width: '100%' }}>
                                    <Col xs={24} span={24}>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="fullname"
                                                        className={cx('item')}
                                                        rules={[{ required: true, message: 'Please enter your first and last name' }]}
                                                    >
                                                        <Input placeholder="Full name *" className={cx('item_input')} />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="CCCD"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                pattern: new RegExp(/([0-9])/),
                                                                message: 'Please enter ID/CCCD number',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="CMND/CCCD *"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="phone"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter phone number',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Phone number *"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="address" className={cx('item')}>
                                                        <Input placeholder="Address" className={cx('item_input')} />
                                                    </Form.Item>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div style={{ padding: '0px 20px 20px 0px' }}>
                                                            <Form.Item
                                                                name="imageFront"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Please select the image of the front of your ID card/CCCD',
                                                                    },
                                                                ]}
                                                            >
                                                                <Upload {...propsBefore} className={cx('uploadImage')}>
                                                                    {imageUrlBefore ? (
                                                                        <img
                                                                            src={imageUrlBefore}
                                                                            alt="avatar"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        uploadButtonFront
                                                                    )}
                                                                </Upload>
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <div style={{ padding: '0px 0px 20px 20px' }}>
                                                            <Form.Item
                                                                name="imageBack"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please select the image on the back of your ID card/CCCD',
                                                                    },
                                                                ]}
                                                            >
                                                                <Upload {...propsAfter} className={cx('uploadImage')}>
                                                                    {imageUrlAfter ? (
                                                                        <img
                                                                            src={imageUrlAfter}
                                                                            alt="avatar"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        uploadButtonBack
                                                                    )}
                                                                </Upload>
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row justify="center">
                                                    <Button
                                                        className={cx('btn_top_up')}
                                                        htmlType="submit"
                                                        style={{ width: 90 }}
                                                    >
                                                        Send
                                                    </Button>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form>
                            ) : userInfo?.collab?.collab_status === 'WAITING' ? (
                                <Col xs={24} span={24}>
                                    <Row justify="center" className={cx('content_collab_waiting')}>
                                        You have submitted information, please wait for admin to review the information!
                                    </Row>
                                </Col>
                            ) : userInfo?.collab?.collab_status === 'CONFIRMED' ? (
                                <Form onFinish={onFinishSendRequirement} style={{ width: '100%' }}>
                                    <Col xs={24} span={24}>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="bank"
                                                        className={cx('item')}
                                                        rules={[
                                                            { required: true, message: 'Please select a bank!' },
                                                        ]}
                                                    >
                                                        <Select
                                                            showSearch
                                                            onChange={handleChange}
                                                            onSearch={onSearch}
                                                            placeholder="Bank"
                                                            optionFilterProp="children"
                                                            // filterOption={(input, option) => option.toLowerCase().includes(input.toLowerCase())}
                                                            // filterSort={(optionA, optionB) =>
                                                            //     optionA.toLowerCase().localeCompare(optionB.toLowerCase())
                                                            // }
                                                        >
                                                            {listBank.length > 0 &&
                                                                listBank.map((item, index) => (
                                                                    <Option
                                                                        key={item.code}
                                                                        value={`${item.code} - ${item.name}`}
                                                                    >
                                                                        {item.code} - {item.name}
                                                                    </Option>
                                                                ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="stk"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                pattern: new RegExp(/([0-9])/),
                                                                message: 'Please enter account number',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Account number"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                        />
                                                    </Form.Item>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="name_tk"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter account name',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Account name"
                                                            className={cx('item_input')}
                                                        />
                                                    </Form.Item>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="moneyWithdraw"
                                                        className={cx('item')}
                                                        shouldUpdate={(prevValues, currentValues) =>
                                                            prevValues.gender !== currentValues.gender
                                                        }
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter the amount to withdraw',
                                                                pattern: new RegExp(/([0-9])/),
                                                            },
                                                            {
                                                                validator: async (_, value) => {
                                                                    if (value > walletRose) {
                                                                        return Promise.reject(
                                                                            new Error(
                                                                                'The amount to withdraw exceeds the commission wallet range!',
                                                                            ),
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <InputNumber
                                                            min={50000}
                                                            // max={walletRose}
                                                            formatter={(value) =>
                                                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                                            }
                                                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                                            style={{ width: '100%' }}
                                                            placeholder="Amount to withdraw (minimum 50,000)"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                            onChange={handleChangeWallet}
                                                        />
                                                    </Form.Item>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={20}>
                                                <Row className={cx('real_money')}>
                                                    Amount received:{getNumberWithCommas(realMoney)}
                                                    {realMoney ? ` d` : ''}
                                                </Row>
                                            </Col>
                                            <Col xs={4}>
                                                <Row justify="end">
                                                    <span className={cx('i_icon')} onClick={() => setIsShowTCN(true)}>
                                                        i
                                                    </span>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row className={cx('TCN')}>
                                                    Personal income tax
                                                    {tax ? `10% (${getNumberWithCommas(tax)} d)` : `0%`}
                                                </Row>
                                            </Col>
                                            {/* <Col xs={4}>
                                                <Row justify="end">
                                                    <span className={cx('i_icon')} onClick={() => setIsShowTCN(true)}>
                                                        i
                                                    </span>
                                                </Row>
                                            </Col> */}
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item name="note" className={cx('item')}>
                                                        <TextArea rows={4} placeholder="Notes" maxLength={255} />
                                                    </Form.Item>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row align="middle" className={cx('note')}>
                                            <Col xs={2} xl={1}>
                                                <span className={cx('i_icon')}>i</span>
                                            </Col>
                                            <Col xs={22} xl={23}>
                                                <span>
                                                    Note that withdrawal requests will be deducted from your commission account if applicable
                                                    Successful withdrawal
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row justify="center">
                                            <Form.Item>
                                                <Button className={cx('btn_top_up')} htmlType="submit">
                                                    Submit a withdrawal request
                                                </Button>
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Form>
                            ) : userInfo?.collab?.collab_status === 'BLOCKED' ? (
                                <Form onFinish={onFinishSendConfirmation} style={{ width: '100%' }}>
                                    <Col xs={24} span={24}>
                                        <Row justify="center" className={cx('content_collab_blocked')}>
                                            Your information has been rejected, please resubmit your information!
                                        </Row>
                                        <Row justify="center">
                                            <Col xs={24}>
                                                <Row justify="end" className={cx('content')}>
                                                    <Form.Item
                                                        name="fullname"
                                                        className={cx('item')}
                                                        rules={[{ required: true, message: 'Please enter your first and last name' }]}
                                                    >
                                                        <Input placeholder="Full name *" className={cx('item_input')} />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="CCCD"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                pattern: new RegExp(/([0-9])/),
                                                                message: 'Please enter ID/CCCD number',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="CMND/CCCD *"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="phone"
                                                        className={cx('item')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter phone number',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Phone number *"
                                                            className={cx('item_input')}
                                                            onKeyDown={checkKeyDownNumberInput}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="address" className={cx('item')}>
                                                        <Input placeholder="Address" className={cx('item_input')} />
                                                    </Form.Item>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div style={{ padding: '0px 20px 20px 0px' }}>
                                                            <Form.Item
                                                                name="imageFront"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Please select the image of the front of your ID card/CCCD',
                                                                    },
                                                                ]}
                                                            >
                                                                <Upload {...propsBefore} className={cx('uploadImage')}>
                                                                    {imageUrlBefore ? (
                                                                        <img
                                                                            src={imageUrlBefore}
                                                                            alt="avatar"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        uploadButtonFront
                                                                    )}
                                                                </Upload>
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12}>
                                                        {' '}
                                                        <div style={{ padding: '0px 0px 20px 20px' }}>
                                                            <Form.Item
                                                                name="imageBack"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please select the image on the back of your ID card/CCCD',
                                                                    },
                                                                ]}
                                                            >
                                                                <Upload {...propsAfter} className={cx('uploadImage')}>
                                                                    {imageUrlAfter ? (
                                                                        <img
                                                                            src={imageUrlAfter}
                                                                            alt="avatar"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        uploadButtonBack
                                                                    )}
                                                                </Upload>
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row justify="center">
                                                    <Button
                                                        className={cx('btn_top_up')}
                                                        htmlType="submit"
                                                        style={{ width: 90 }}
                                                    >
                                                        Send
                                                    </Button>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form>
                            ) : (
                                ''
                            )}
                        </Row>
                    </div>
                    {/* <Form onFinish={onFinishSendRequirement} className={cx('right_container')}>
                        <Wallet showAmount={showAmount}></Wallet>
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        <Row className={cx('table_container')}>
                            <Col className={cx('tab_section')}>
                                <div className={cx('tab_item', 'tab_item_selected')}>Withdrawal information</div>
                            </Col>

                            <Col span={24}>
                                <Row justify="center">
                                    <Col xs={24}>
                                        <Row justify="end" className={cx('content')}>
                                            <Form.Item
                                                name="bank"
                                                className={cx('item')}
                                                rules={[{ required: true, message: 'Please select a bank!' }]}
                                            >
                                                <Select
                                                    showSearch
                                                    onChange={handleChange}
                                                    onSearch={onSearch}
                                                    placeholder="Bank"
                                                    optionFilterProp="children"
                                                    // filterOption={(input, option) => option.toLowerCase().includes(input.toLowerCase())}
                                                    // filterSort={(optionA, optionB) =>
                                                    //     optionA.toLowerCase().localeCompare(optionB.toLowerCase())
                                                    // }
                                                >
                                                    {listBank.length > 0 &&
                                                        listBank.map((item, index) => (
                                                            <Option
                                                                key={item.code}
                                                                value={`${item.code} - ${item.name}`}
                                                            >
                                                                {item.code} - {item.name}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={24}>
                                        <Row justify="end" className={cx('content')}>
                                            <Form.Item
                                                name="stk"
                                                className={cx('item')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        pattern: new RegExp(/([0-9])/),
                                                        message: 'Please enter account number',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Account number"
                                                    className={cx('item_input')}
                                                    onKeyDown={checkKeyDownNumberInput}
                                                />
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={24}>
                                        <Row justify="end" className={cx('content')}>
                                            <Form.Item
                                                name="name_tk"
                                                className={cx('item')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter account name',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="Account name" className={cx('item_input')} />
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={24}>
                                        <Row justify="end" className={cx('content')}>
                                            <Form.Item
                                                name="moneyWithdraw"
                                                className={cx('item')}
                                                shouldUpdate={(prevValues, currentValues) =>
                                                    prevValues.gender !== currentValues.gender
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter the amount to withdraw',
                                                        pattern: new RegExp(/([0-9])/),
                                                    },
                                                    {
                                                        validator: async (_, value) => {
                                                            if (value > walletRose) {
                                                                return Promise.reject(
                                                                    new Error(
                                                                        'The amount to withdraw exceeds the commission wallet range!',
                                                                    ),
                                                                );
                                                            }
                                                        },
                                                    },
                                                ]}
                                            >
                                                <InputNumber
                                                    min={50000}
                                                    // max={walletRose}
                                                    formatter={(value) =>
                                                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                                    }
                                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                                    style={{ width: '100%' }}
                                                    placeholder="Amount to withdraw (minimum 50,000)"
                                                    className={cx('item_input')}
                                                    onKeyDown={checkKeyDownNumberInput}
                                                />
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={24}>
                                        <Row justify="end" className={cx('content')}>
                                            <Form.Item name="note" className={cx('item')}>
                                                <TextArea rows={4} placeholder="Notes" />
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Form.Item>
                                        <Button className={cx('btn_top_up')} htmlType="submit">
                                            Submit a withdrawal request
                                        </Button>
                                    </Form.Item>
                                </Row>
                            </Col>
                        </Row>
                    </Form> */}
                </div>
            </div>
            {isShowTCN && (
                <Modal
                    centered
                    visible={isShowTCN}
                    onCancel={() => setIsShowTCN(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormCanNot
                            onAgree={() => setIsShowTCN(false)}
                            text={contentTCN}
                            textAlignStart={true}
                            title="Terms information"
                            btnBottom={false}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Withdraw;
